import { Flowbite } from "flowbite-react";
import moment from "moment-timezone";
import "moment/locale/ko";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { CustomProvider } from "./components/provider/CustomProvider";
import "./index.css";
import { customRouter } from "./router/custom-router";
import { customTheme } from "./themes/custom-theme";
import "./tracing";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

moment().tz("Asia/Seoul");
moment.locale("ko");

root.render(
  <React.StrictMode>
    <CustomProvider>
      <Flowbite theme={{ theme: customTheme }}>
        <RouterProvider router={customRouter} />
      </Flowbite>
    </CustomProvider>
  </React.StrictMode>
);

// md: 416,
// 2xl: 620,
// 4xl: 864,
// 7xl: 1248,
